import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Button } from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const BookingSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id');

  return (
    <div className="flex flex-col items-center justify-center min-h-[80vh] px-6 text-center max-w-2xl mx-auto">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6">
        <SafeIcon icon={FiIcons.FiCheck} className="text-4xl text-green-700" />
      </div>
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Payment Successful!</h2>
      <p className="text-gray-700 mb-2">
        Your deposit has been received and your booking is confirmed.
      </p>
      <p className="text-gray-500 text-sm mb-8">
        You will receive a confirmation email with all the details shortly.
      </p>
      {sessionId && (
        <p className="text-xs text-gray-400 mb-6">
          Reference: {sessionId.slice(0, 20)}...
        </p>
      )}
      <Button onClick={() => window.location.href = '/'} className="min-w-[160px] font-bold">
        Back to Home
      </Button>
    </div>
  );
};

export default BookingSuccess;
